import { getCookieAccessToken } from '@wiggot/auth/services/token-service'
import { defaultApiBasic, legacyApiAuth } from '../../apis'

export const postLogOut = async () => {
  try {
    await legacyApiAuth.post('/v2.0.2/user/logout', {})
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const postLogOutV2 = async () => {
  try {
    const { decodeAccessToken } = getCookieAccessToken() ?? {}
    const { id } = decodeAccessToken?.user ?? {}
    if (!id) {
      throw new Error('User not found')
    }
    await defaultApiBasic.post('/users-management/logout', {
      userId: id,
      source: 'PORTAL'
    })
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const postResendEmailVerification = async ({
  email
}: {
  email: string
}) => {
  try {
    await legacyApiAuth.post('/v2.0.2/user/resend-verification', {
      email
    })
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}

export const getValidateToken = async () => {
  try {
    await legacyApiAuth.get('/v2.0.2/user/validate_token')
    return {
      isSuccess: true
    }
  } catch (error: any) {
    return {
      isSuccess: false,
      error
    }
  }
}
